<div class="loadingContainer">
<dx-load-indicator
[width]="60"
[height]="60"
></dx-load-indicator>
</div>